import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { User } from '../model/user/user';

@Injectable()
export class AuthService {
  public user: Observable<firebase.User>;
  public userDetails: firebase.User = null;
  public loggedIn: boolean;
  constructor(private _firebaseAuth: AngularFireAuth, private router: Router, private _firestore: AngularFirestore) {
    
    this.loggedIn = !!localStorage.getItem('userAuth');
    this.userDetails = JSON.parse(localStorage.getItem('userAuth'));

    /*
    this.user = _firebaseAuth.authState;
    this.user.subscribe(
      (user) => {
        if (user) {
          this.userDetails = user;
          //console.log(this.userDetails);
        }
        else {
          this.userDetails = null;
        }
      },
    );
    */
  }


  register(email: string, password: string) {
    return this._firebaseAuth.createUserWithEmailAndPassword(email, password);
    
  }

  getCurrentUser(): string | any {
    return localStorage.getItem('userAuth') || undefined;
  }


  requestPass(email) {
    return this._firebaseAuth.sendPasswordResetEmail(email);
  }

  confirmPasswordReset(code, newPassword) { // param: oobCode=<code>
    return this._firebaseAuth.confirmPasswordReset(code, newPassword);
  }

  /*verifyPasswordResetCode(code){
    return this._firebaseAuth.auth.verifyPasswordResetCode(code);
  }*/

  signInWithEmail(email, password) {
    return this._firebaseAuth.signInWithEmailAndPassword(email, password);
  }

  signInWithTwitter() {
    return this._firebaseAuth.signInWithPopup(
      new firebase.auth.TwitterAuthProvider(),
    )
  }
  signInWithFacebook() {
    return this._firebaseAuth.signInWithPopup(
      new firebase.auth.FacebookAuthProvider(),
    )
  }
  signInWithGoogle() {
    return this._firebaseAuth.signInWithPopup(
      new firebase.auth.GoogleAuthProvider(),
    )
  }

  isLoggedIn() {
    
    return !!localStorage.getItem('userAuth');
    /*
    if (this.userDetails == null) {
      return false;
    } else {
      return true;
    }
    */
  }

  logout() {
    localStorage.removeItem('userAuth');
    this._firebaseAuth.signOut()
      .then((res) => this.router.navigate(['/auth/login']));
  }

  updateUserDetails(userDetails: firebase.User, user: User){
    userDetails.updateProfile({
      displayName: user.firstName + " " + user.lastName,
      photoURL: ""
    }).then(function() {
      // Update successful.
    }).catch(function(error) {
      // An error happened.
    });
    
  }

  sendEmailVerification(){
    return firebase.auth().currentUser.sendEmailVerification();
  }
}